import { useQueryClient } from "@tanstack/react-query";

import API from "../../..";
import { useMutationWrapper } from "../../wrappers";
import { roomDetailsKey, roomListKey, swapDeviceKey } from "../room-query-keys";
import { useApiError } from "@/lib/hooks";

export const useMutationSwapDevice = (roomId: string, onSuccess: () => void) => {
  const queryCache = useQueryClient();
  const { handleErrors } = useApiError();

  const { mutate, isPending, isSuccess, isError } = useMutationWrapper({
    mutationKey: swapDeviceKey(roomId),
    mutationFn: API.Rooms.swapDevice,
    onSuccess: async () => {
      await Promise.all([
        queryCache.invalidateQueries({ queryKey: roomListKey() }),
        queryCache.invalidateQueries({ queryKey: roomDetailsKey(roomId) }),
      ]);
      onSuccess();
    },
    onError: handleErrors,
  });

  return { mutate, isPending, isSuccess, isError };
};
